// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__18vKu","label":"Completed_label__32wl_"};